<app-skill-builder-text-list
	[mainTitle]="page.title"
	[textInputs]="actions"
	[disclaimer]="disclaimer"
	[next]="next"
	[validationError]="page.error1"
	[parentLoaded]="loaded.toPromise()"
	[min]="min"
></app-skill-builder-text-list>
